var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62648 16.4929C9.40871 16.721 9.04218 16.7132 8.83429 16.476V16.476C8.65094 16.2669 8.65764 15.9524 8.84973 15.7512L14.3749 9.96518C15.113 9.19225 15.113 7.97562 14.3749 7.2027L8.84973 1.41667C8.65764 1.21551 8.65094 0.900979 8.83429 0.691831V0.691831C9.04218 0.454686 9.40871 0.4469 9.62648 0.675001L15.8588 7.20285C16.5967 7.97574 16.5967 9.19214 15.8588 9.96503L9.62648 16.4929ZM11.4429 9.96502C12.1808 9.19214 12.1808 7.97574 11.4429 7.20285L5.2106 0.675002C4.99283 0.4469 4.6263 0.454686 4.41841 0.691831V0.691831C4.23506 0.900979 4.24176 1.21551 4.43385 1.41667L9.95907 7.2027C10.6971 7.97562 10.6972 9.19225 9.95907 9.96518L4.43385 15.7512C4.24176 15.9524 4.23506 16.2669 4.41841 16.476V16.476C4.6263 16.7132 4.99283 16.721 5.2106 16.4929L11.4429 9.96502Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_1235",
    x: 0.285218,
    y: 0.285218,
    width: 20.127,
    height: 24.1503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_1235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_1235",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/next-button.c1342054c126439a97bb03a352beeb8b.svg";
export { ForwardRef as ReactComponent };